import { ArrowUpRight, FileCode2, ShieldCheck } from 'lucide-react';
import { getLegacyAtsUrl } from '@/lib/environment';
import { interpolateLegacyPath, type AppRoute } from './page-registry';
import { useLocation } from 'react-router-dom';

export function MigrationPage({ route }: { route: Omit<AppRoute, 'element'> }) {
  const location = useLocation();
  const legacyPath = interpolateLegacyPath(route as AppRoute, location.pathname);
  const legacyHref = `${getLegacyAtsUrl()}${legacyPath}`;
  const Icon = route.icon;

  return (
    <section className="page-surface migration-page">
      <header className="page-header">
        <div className="page-title-row">
          <span className="page-icon">
            <Icon size={20} />
          </span>
          <div>
            <p className="eyebrow">Migration target</p>
            <h1>{route.title}</h1>
          </div>
        </div>
        <a className="secondary-button" href={legacyHref} target="_blank" rel="noreferrer">
          Open legacy page <ArrowUpRight size={15} />
        </a>
      </header>

      <div className="migration-grid">
        <article className="work-card">
          <div className="card-heading">
            <FileCode2 size={18} />
            <h2>Source</h2>
          </div>
          <p>{route.sourcePath || 'Source path pending.'}</p>
        </article>
        <article className="work-card">
          <div className="card-heading">
            <ShieldCheck size={18} />
            <h2>Status</h2>
          </div>
          <p>
            The SPA route, auth guard, tabs, desktop chrome, and legacy escape hatch are ready.
            The page body can now be ported without changing navigation behavior.
          </p>
        </article>
      </div>

      <div className="migration-panel">
        <h2>{route.subtitle || route.title}</h2>
        <p>
          This placeholder keeps the final URL, tab label, permission metadata, and legacy path stable while
          the implementation moves from the Next app into Vite.
        </p>
      </div>
    </section>
  );
}
